export const addPaymentReducer = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_PAYMENT_REQUEST':
      return {
        loading: true,
      };
    case 'ADD_PAYMENT_SUCCESS':
      return {
        loading: false,
        success: true,
        payment: action.payload,
      };
    case 'ADD_PAYMENT_ERROR':
      return {
        loading: false,
        success: false,
        message: action.payload,
      };
    default:
      return state;
  }
};

export const userAllPaymentByIdReducer = (state = { payment: [] }, action) => {
  switch (action.type) {
    case 'USER_PAYMENT_REQUEST':
      return {
        loading: true,
      };
    case 'USER_PAYMENT_SUCCESS':
      return {
        loading: false,
        success: true,
        payment: [...action.payload.user.payments],
      };
    case 'USER_PAYMENT_ERROR':
      return {
        loading: false,
        success: false,
        message: action.payload,
      };
    default:
      return state;
  }
};

export const getAllPaymentReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case 'GET_ALL_PAYMENT_REQUEST':
      return {
        loading: true,
      };
    case 'GET_ALL_PAYMENT_SUCCESS':
      return {
        loading: false,
        success: true,
        payments: action.payload,
      };
    case 'GET_ALL_PAYMENT_ERROR':
      return {
        loading: false,
        success: false,
        message: action.payload,
      };
    default:
      return state;
  }
};

export const updatePaymentReducer = (state = {}, action) => {
  switch (action.type) {
    case 'UPDATE_PAYMENT_REQUEST':
      return {
        loading: true,
      };
    case 'UPDATE_PAYMENT_SUCCESS':
      return {
        loading: false,
        success: true,
      };
    case 'UPDATE_PAYMENT_FAILED':
      return {
        loading: false,
        success: false,
        message: action.payload,
      };
    default:
      return state;
  }
};
